import React from 'react';

import {
  Grid,
  Button,
} from '@material-ui/core';

import InputField from '../../common/components/inputField';

import classes from '../../css/getCSS';


const deleteForm = (props) => {
  return (
    <React.Fragment>
      <Grid container spacing={24}>
        <Grid item md={12} xs={12} sm={6}>
          <InputField
            id="reason"
            config={props.inputs.reason}
            changed={event => props.inputChangedHandler(event, 'reason')}
          />
        </Grid>
        <Grid item md={12} xs={12} sm={6}>
          <InputField
            id="message"
            config={props.inputs.message}
            changed={event => props.inputChangedHandler(event, 'message')}
          />
        </Grid>
      </Grid>
      <br />
      <Button variant="contained" color="primary" type="submit" size="large" className={classes.Button}>
        Delete
      </Button>
    </React.Fragment>
  );
};

export default deleteForm;



// WEBPACK FOOTER //
// ./src/profile/components/DeleteProfileForm.js